import locations from './locations.js'

const state = {
  model: {
    id: null,
    name: ''
  },
  loading: false
}
export const getters = {
  model: state => state.model,
  loading: state => state.loading
}

export const mutations = {
  set(state, organization) {
    state.model = organization
  },
  setLoading(state, loadingState) {
    state.loading = loadingState
  }
}

export const actions = {
  fetch({ commit }) {
    commit('setLoading', true)
    return api
      .getOrganization()
      .then(({ data }) => commit('set', data), commit('setLoading', false))
  },
  update({ commit }, organization) {
    return api
      .patchOrganization(organization)
      .then(({ data }) => commit('set', data), ({ data }) => data.errors)
  }
}

export const api = {
  getOrganization: () => Vue.$http.get('client/organization'),
  patchOrganization: organization =>
    Vue.$http.patch('client/organization', { organization })
}

export default {
  state,
  getters,
  mutations,
  actions,
  namespaced: true,
  modules: {
    locations
  }
}
